import React from "react";
import PropTypes from "prop-types";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import isMobile from "~/utils/isMobile";

const backend = isMobile() ? TouchBackend : HTML5Backend;

function CustomDndProvider({ children }) {
  return <DndProvider backend={backend}>{children}</DndProvider>;
}

CustomDndProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomDndProvider;
